import { setCircleSwatchWidth } from './product-card-shape-swatches.js';
import { bindSwatchesClick, bindQuickAddSizeBtnClick, bindQuickAddMobileClick } from './quick-purchase.js';

const interval = setInterval(() => {
    if (document.querySelector('.product-recommendations .slider-grid__slide')) {
      clearInterval(interval);
      console.log('Product recommendations loaded!');
      // 你可以在这里执行后续逻辑
      setCircleSwatchWidth(".product-recommendations__container");
      bindSwatchesClick(".product-recommendations__container");
      bindQuickAddSizeBtnClick(".product-recommendations__container");
      bindQuickAddMobileClick(".product-recommendations__container");
    }
}, 100);